import { render } from "./VR.vue?vue&type=template&id=6b73b73d&scoped=true&ts=true"
import script from "./VR.vue?vue&type=script&lang=ts"
export * from "./VR.vue?vue&type=script&lang=ts"

import "./VR.vue?vue&type=style&index=0&id=6b73b73d&lang=scss&scoped=true"

import exportComponent from "C:\\work\\h5\\yulinxing\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b73b73d"]])

export default __exports__